export default __webpack_public_path__ + "static/media/Carola Susani e Paolo Ciampi.079c6a67.jpg";